<template>
  <initio-panel :hideSubmit="true" :hideBack="true" :hideProgressBar="true">
    <template v-slot:title>
      <AnimatedCheckmark/>
      <h1 class="has-text-centered has-text-weight-black">Thanks, your car is now insured with initio</h1>
    </template>
    <template v-slot:before_form>

      <div class="has-text-centered">

        <div class="columns">
          <div class="column">

            <span class="is-size-5 underlined has-text-weight-bold">
              <span class="plate">{{ getAnswer('plate','vehicle_plate') }}</span> - <span class="full_model">{{ getAnswer('plate','vehicle_year') }} {{ getAnswer('plate','vehicle_make') }} {{ getAnswer('plate','vehicle_model') }}</span>
            </span>

            <div class="is-size-5 mb-6">
              We've sent you an email with your policy schedule and invoice.
            </div>

          </div>
        </div>

        <div class="columns is-centered">
          <div class="column is-4 has-text-right-tablet">
            <CustomButton leftIcon="calendar" rightIcon="download" :url="getAnswer('Vehicle.Success','schedule_url')">Policy schedule</CustomButton>
          </div>
          <div class="column is-narrow">
            <CustomButton leftIcon="file" rightIcon="download" :url="getAnswer('Vehicle.Success','policy_wording_url')">Policy wording</CustomButton>
          </div>
          <div class="column is-4 has-text-left-tablet">
            <CustomButton leftIcon="award" rightIcon="download" :url="getAnswer('Vehicle.Success','certificate_url')">Bank Certificate</CustomButton>
          </div>
          <!--
          <div class="column is-4 has-text-left">
            <CustomButton leftIcon="award" rightIcon="download" :url="getAnswer('Vehicle.Success','invoice_url')">Invoice</CustomButton>
          </div>
          -->
        </div>

        <p><a href="/app/member/dashboard" class="button button is-medium is-primary my-6" >Visit your dashboard</a></p>

        <Founders/>
      </div>
    </template>
  </initio-panel>
</template>

<script>


import InitioSummary from '@/components/partials/Summary.vue'
import InitioPanel from '@/components/initio/InitioPanel.vue'

import { mapGetters } from 'vuex'
import AnimatedCheckmark from "@/components/partials/AnimatedCheckmark";
import Founders from "@/components/partials/Founders";
import CustomButton from "@/components/partials/CustomButton";

export default {
  components: {
    CustomButton,
    Founders,
    AnimatedCheckmark,
    InitioPanel
  },
  mixins: [

  ],
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers', getAnswer: 'getAnswer' }),
  },
  mounted () {
    // Associate cli_num with hotjar recording
    const cli_num = this.getAnswer('Vehicle.Success','cli_num');
    if( window.hj && cli_num ){
      try {
        // Make sure there is the hotjar on the window
        var userId = cli_num || null; // Replace your_user_id with your own if available.
        window.hj('identify', userId, {});
      } catch(e){
        console.log('problem logging client with hotjar');
      }
    }
  },
  methods: {

  },
  data () {
    return {
      errors: [],
    }
  }
}

</script>

<style scoped lang="scss">
h1 {
  font-size:2.125rem;
}
.underlined{
  padding-bottom: 5px;
  border-bottom: 2px solid #82B541;
  line-height: 39.5px;
  color: black !important;
}

.button {

}
</style>